import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useEditSynthesis from "../../../../hooks/tableNotes/useEditSynthesis";

const EditSynthesis = ({ token, open, close, note, onSaveSuccess }) => {
  const {
    title,
    synthesis,
    loading,
    error,
    saveSuccess,
    setSaveSuccess,
    handleSynthesisChange,
    handleSubmit,
    handleClose,
  } = useEditSynthesis(token, note, onSaveSuccess, close);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: 3,
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#f5f5f5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          px: 3,
          py: 2,
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ fontWeight: "bold", color: "#235789" }}
        >
          Editar síntesis
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          disabled={loading}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3, mt: 1 }}>
        <TextField
          autoFocus
          margin="dense"
          id="title"
          label="Título"
          type="text"
          fullWidth
          variant="outlined"
          value={title}
          disabled={true}
          sx={{ mb: 2 }}
          InputLabelProps={{
            shrink: true,
          }}
        />

        <TextField
          margin="dense"
          id="synthesis"
          label="Contenido de la síntesis"
          multiline
          rows={6}
          fullWidth
          variant="outlined"
          value={synthesis}
          onChange={handleSynthesisChange}
          disabled={loading}
          InputLabelProps={{
            shrink: true,
          }}
        />

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
          px: 3,
          py: 2,
          backgroundColor: "#f5f5f5",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Button
          onClick={handleClose}
          color="inherit"
          disabled={loading}
          variant="outlined"
          sx={{ mr: 1 }}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !synthesis.trim()}
          startIcon={
            loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : saveSuccess ? (
              <CheckCircleIcon />
            ) : (
              <SaveIcon />
            )
          }
          sx={{
            backgroundColor: saveSuccess ? "#43a047" : "#235789",
            "&:hover": {
              backgroundColor: saveSuccess ? "#2e7d32" : "#1c4674",
            },
          }}
        >
          {loading ? "Guardando..." : saveSuccess ? "¡Guardado!" : "Guardar"}
        </Button>
      </DialogActions>

      <Snackbar
        open={saveSuccess}
        autoHideDuration={6000}
        onClose={() => setSaveSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" variant="filled">
          Síntesis actualizada correctamente
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default EditSynthesis;
